









import { Component, Vue, Watch } from "vue-property-decorator"
import tabbar from "@/components/tabbar.vue"

@Component({
	components: {
		tabbar
	}
})
export default class Default extends Vue {
	@Watch("name")
	getWatchValue(newVal: string, oldVal: string) {
		console.log(newVal, oldVal)
	}

	created() {}

	mounted() {}
}
